import { atom } from "recoil";

export const tenantDetailsState = atom({
  key: "tenantDetailsState", // unique ID (with respect to other atoms/selectors)
  default: null, // default value (aka initial value)
});
